import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useCallback, useSyncExternalStore } from 'react';

export function useOnTop(navigation: NativeStackNavigationProp<any>) {
  const subscribe = useCallback(
    (callback: () => void) => {
      const unsubscribeFocus = navigation.addListener('focus', callback);
      const unsubscribeBlur = navigation.addListener('blur', callback);

      return () => {
        unsubscribeFocus();
        unsubscribeBlur();
      };
    },
    [navigation],
  );

  const value = useSyncExternalStore(
    subscribe,
    navigation.isFocused,
    navigation.isFocused,
  );

  return value;
}
